import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyComponent } from '../currency/currency.component';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [CommonModule, CurrencyComponent],
  selector: 'lx-price-lists-portal-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss', './print-table-header.component.scss'],
})
export class TableHeaderComponent {
  @Input() title: string | undefined;
  @Input() currency: Currency | undefined;
}
